import PropTypes from "prop-types";

export const TextItems = ({ text, style = {} }) => {
  return (
    <div className="globalComponentContainer footer-content--text-items-box">
      {text?.staticValue?.filter(Boolean).map((item, i) => (
        <div
          key={`${item}-${i}`}
          className="footer-content--text-item"
          style={style}
          dangerouslySetInnerHTML={{ __html: item }}
        />
      ))}
    </div>
  );
};

TextItems.propTypes = {
  style: PropTypes.object,
  text: PropTypes.shape({
    staticValue: PropTypes.arrayOf(PropTypes.string),
  }),
};
